export const classes = [
  {
    nom: "6e A",
    nbEleves: 27,
    niveau: "6e",
  },
  {
    nom: "5e B",
    nbEleves: 25,
    niveau: "5e",
  },
  {
    nom: "4e C",
    nbEleves: 28,
    niveau: "4e",
  },
];